import { Search, X, MapPin, Locate, Layers } from "lucide-react";

/**
 * Search bar row with tile toggle + locate button.
 * Purely presentational — parent owns state.
 */
export default function MapSearchBar({
  query, onQueryChange, onClear, suggestions, loading, onPick, tile, onToggleTile, onLocate,
}) {
  return (
    <div className="rounded-lg border border-border bg-card p-3 flex flex-col sm:flex-row items-stretch gap-2">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" strokeWidth={1.75} />
        <input
          data-testid="map-search-input"
          type="text"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search address, village, town, landmark..."
          className="w-full h-10 pl-10 pr-9 rounded-md border border-border bg-background text-sm outline-none focus:ring-2 focus:ring-primary/40"
        />
        {query && (
          <button aria-label="Clear" onClick={onClear} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground">
            <X className="h-4 w-4" />
          </button>
        )}
        <SuggestionList suggestions={suggestions} onPick={onPick} />
        {loading && <div className="absolute right-9 top-1/2 -translate-y-1/2 text-[10px] text-muted-foreground uppercase tracking-widest">searching…</div>}
      </div>
      <div className="flex gap-2">
        <button data-testid="map-locate-btn" onClick={onLocate} className="h-10 px-3 rounded-md border border-border bg-background hover:bg-accent text-xs font-medium flex items-center gap-1.5" title="My location">
          <Locate className="h-4 w-4" strokeWidth={1.75} /> <span className="hidden sm:inline">My location</span>
        </button>
        <button data-testid="map-tile-toggle" onClick={onToggleTile} className="h-10 px-3 rounded-md border border-border bg-background hover:bg-accent text-xs font-medium flex items-center gap-1.5">
          <Layers className="h-4 w-4" strokeWidth={1.75} /> {tile === "satellite" ? "Satellite" : "Street"}
        </button>
      </div>
    </div>
  );
}

function SuggestionList({ suggestions, onPick }) {
  if (!suggestions.length) return null;
  return (
    <div className="absolute z-[500] mt-1 w-full rounded-md border border-border bg-popover shadow-lg overflow-hidden" data-testid="map-search-results">
      {suggestions.map((s) => (
        <button
          key={s.place_id}
          data-testid={`map-suggestion-${s.place_id}`}
          onClick={() => onPick(s)}
          className="w-full flex items-start gap-2 px-3 py-2.5 text-left text-sm hover:bg-accent border-b border-border/60 last:border-b-0"
        >
          <MapPin className="h-3.5 w-3.5 mt-1 text-primary shrink-0" strokeWidth={1.75} />
          <span className="line-clamp-2">{s.display_name}</span>
        </button>
      ))}
    </div>
  );
}
